// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__WyXJ8","rotate":"style_rotate__uak1t","path":"style_path__QXyPM","dash":"style_dash__VdqCl"};